module.exports = __webpack_public_path__ + "img/slide11-piece-33.0bd624f8.png";